import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/fonts.tsx\",\"import\":\"Agbalumo\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"weight\":\"400\"}],\"variableName\":\"agbalumo\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/fonts.tsx\",\"import\":\"Work_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\"],\"style\":[\"normal\",\"italic\"]}],\"variableName\":\"work_sans\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/_components/client-script.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/_components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/_components/menus/navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/_components/overlay.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/store/hydration.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/globals.css");
